// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
import api from './utils/api.js'
import 'element-ui/lib/theme-chalk/index.css';
import './assets/fonts/iconfont.css'
import navList from './utils/navList'
import provinceData from './utils/provinceData'
import validate from './utils/validate'
import VideoPlayer from 'vue-video-player'
import 'swiper/js/swiper.min'
import 'swiper/css/swiper.min.css'
require('video.js/dist/video-js.css')
require('vue-video-player/src/custom-theme.css')

import '../static/tinymce/skins/ui/oxide/skin.min.css'; //富文本样式
import tinymce from 'tinymce/tinymce'; //配置富文本
import 'tinymce/themes/silver/theme.min.js' //引入富文本的主要脚本
import Editor from '@tinymce/tinymce-vue'; //引用富文本组件
import lang from '../static/tinymce/langs/zh_CN.js'; //引用中文语言
import $url from './utils/url.js'
import * as echarts from 'echarts'

tinymce.addI18n('zh_CN', lang); //注册中文语言，这里配置不起作用后面还可以配置
Vue.component('editor', Editor); //注册全局组件

Vue.prototype.$bus = new Vue
Vue.use(VideoPlayer)
Vue.prototype.api = api
Vue.config.productionTip = false
Vue.prototype.navList = navList
Vue.prototype.provinceData = provinceData
Vue.prototype.validate = validate
Vue.prototype.$url = $url
Vue.prototype.$echarts = echarts

Vue.prototype.resetSetItem = function (key, newVal) {
    // 创建一个StorageEvent事件
    let newStorageEvent = document.createEvent('StorageEvent');
    const storage = {
        setItem: function (k, val) {
            sessionStorage.setItem(k, val);
            // 初始化创建的事件
            newStorageEvent.initStorageEvent('setItem', false, false, k, null, val, null, null);
            // 派发对象
            window.dispatchEvent(newStorageEvent)
        }
    }
    return storage.setItem(key, newVal);
}
Vue.use(ElementUI)
new Vue({
    el: '#app',
    router,
    store,
    components: {App},
    template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js